import { render, staticRenderFns } from "./BuyFooter.vue?vue&type=template&id=725fcdf4&scoped=true&"
import script from "./BuyFooter.vue?vue&type=script&lang=js&"
export * from "./BuyFooter.vue?vue&type=script&lang=js&"
import style0 from "./BuyFooter.vue?vue&type=style&index=0&id=725fcdf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725fcdf4",
  null
  
)

export default component.exports